import React, { useCallback } from 'react';

import { Marker } from 'react-google-maps';

const DriverMarker = ({
  handleClick,
  latitude,
  longitude,
  icon,
  driver_id,
  location_mode,
  timestamp,
}) => {
  const onClick = useCallback(() => {
    handleClick({ driver_id, location_mode, timestamp });
  }, [handleClick, driver_id, location_mode, timestamp]);

  return (
    <Marker
      key={driver_id}
      position={{ lat: latitude, lng: longitude }}
      icon={icon}
      onClick={onClick}
    />
  );
};

const DriverMarkers = ({ onClick, driverMarkers }) => {
  return driverMarkers.map((marker) => <DriverMarker {...marker} handleClick={onClick} />);
};

export default DriverMarkers;
